import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { GlobalsService } from 'app/common/services/globals.service';
import { ConventionRegistrationService } from 'app/convention-registration/convention-registration.service';
import { LinkHEUConvention } from 'app/models/link-h-e-u-convention.model';
import { RegistrationTypeEnum } from 'app/models/lookup-enums.model';
import { BaseComponent, PaginationComponent, PersistData, ProgressBarService } from '@mrm/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'emreg-heu-picker',
  templateUrl: './heu-picker.component.html'
})
export class HeuPickerComponent extends BaseComponent implements OnInit {
  @Input() id: string;
  @Input() regType: RegistrationTypeEnum;
  @Input() canClose: boolean = false;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(PaginationComponent, { static: true }) paginator: PaginationComponent;

  linkHEUConventions: LinkHEUConvention[] = [];
  displayedColumns = ['actions', 'localNumber', 'localName', 'provinceDBID', 'city', 'status'];
  heuDataSource: MatTableDataSource<LinkHEUConvention>;
  totalResults: number = 0;

  constructor(
    private __progressBarService: ProgressBarService,
    private __toastr: ToastrService,
    private __translateService: TranslateService,
    private __router: Router,
    private _activeModal: NgbActiveModal,
    private _globalsService: GlobalsService,
    private _persistData: PersistData,
    private _conventionRegistrationService: ConventionRegistrationService
  ) {
    super(__progressBarService, __toastr, __translateService, __router);
  }

  ngOnInit() {
    // Hack to not have HEU dialog show twice.  Close modal on second time.
    if (this._persistData.get('closeHEU')) {
      this._persistData.removeKey('closeHEU');
      this._activeModal.dismiss();
    } else {
      this._loadData();
    }
  }

  onCancel() {
    this._activeModal.dismiss();
  }

  selectHeu(linkHEUConvention: LinkHEUConvention) {
    this._activeModal.close(linkHEUConvention);
  }

  applyFilter(filterValue: string) {
    this.heuDataSource.filter = filterValue.trim().toLowerCase();
    this.paginator.refresh();
  }

  private _loadData() {
    this._progressBarService.start();

    this._conventionRegistrationService.getHeuValues(this.regType, this.id)
      .subscribe(this._onLoadDataSuccess.bind(this), this.displayError.bind(this));
  }

  private _onLoadDataSuccess(linkHEUConventions: LinkHEUConvention[]) {
    this.linkHEUConventions = linkHEUConventions;
    this._reloadDataSource();
    this._progressBarService.stop();
  }

  private _reloadDataSource() {
    this.heuDataSource = new MatTableDataSource(this.linkHEUConventions);
    this.totalResults = this.linkHEUConventions.length;
    this.paginator.length = this.linkHEUConventions.length;
    this.paginator.refresh();
    this.heuDataSource.paginator = this.paginator;
    this.heuDataSource.sort = this.sort;
    this.heuDataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'heu.localNumber': return item.heu == null ? '' : item.heu.localNumber;
        case 'heu.localName': return item.heu == null ? '' : item.heu.localName;
        case 'heu.city': return item.heu == null ? '' : item.heu.city;
        case 'heu.provinceDBID': return item.heu == null ? '' : this._globalsService.provinces.find(x => x.id == item.heu.provinceDBID).value;
        default: return item[property];
      }
    };

    this.heuDataSource.filterPredicate = (data, filter) => {
      const cityString = data.heu.city != null ? data.heu.city.toLowerCase() : '';
      const provinceString = this._globalsService.provinces.find(x => x.id == data.heu.provinceDBID).value.toLowerCase();

      const dataStr = data.heu.localNumber + data.heu.localName.toLowerCase() + provinceString + cityString;
      return dataStr.indexOf(filter) != -1;
    };
  }
}
